import styled from "styled-components";
import { Wrapper as AccessoriesWrapper } from "../common/accessories/Accessories.styles";
import * as AccessoryContainerStyles from "../common/accessories/AccessoriesContainer.styles";
import * as PdpServicesStyles from "../common/services/PdpServices.styles";

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-1) / 2);

    @supports not (row-gap: 0) {
        & > * {
            margin-bottom: var(--spacing-3);
        }
    }
`;

export const Group = styled.div`
    display: flex;
    flex-direction: column;

    & > aside {
        display: flex;
        flex-direction: column;
        row-gap: var(--spacing-2);
    }

    /* 
    Only add a margin to the header if there are accessories present
    Because stylelint doesn't understand that ${Header} and ${AccessoriesWrapper} are
    valid selectors, we need to disable the rule for this line. This solution is imo
    better than prop drilling.
     */
    /* stylelint-disable-next-line selector-type-no-unknown */
    & > ${Header}:has(+ ${AccessoriesWrapper}:not(:empty)) {
        margin-block-end: var(--spacing-4);
    }

    @supports not (row-gap: 0) {
        & > div:not(:first-child) {
            margin-top: var(--spacing-4);
        }
    }
`;

export const AccessoriesAndServicesGroup = styled.div`
    display: flex;
    flex-direction: column;

    ${AccessoryContainerStyles.Wrapper},
    ${PdpServicesStyles.Wrapper} {
        margin-bottom: var(--spacing-7);
    }
`;

export const AccessoriesAndServicesHeader = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-1) / 2);
    margin-bottom: var(--spacing-4);

    @supports not (row-gap: 0) {
        & > * {
            margin-bottom: var(--spacing-3);
        }
    }
`;
